import { FETCH_DESTINATIONS, FETCH_DESTINATIONS_FAIL, CLEAR_BUILDER_LIST  } from '../actions/types';
import update from 'immutability-helper';


const destinationInitalState = {
  isFetching:true,
  data:[]
}

export function Destinations(state = destinationInitalState, action){
  switch (action.type) {

   case FETCH_DESTINATIONS:
      return update(state, {
        isFetching:{$set:false},
        data:{$set:action.payload.data.data}
      });


    case CLEAR_BUILDER_LIST:
    case FETCH_DESTINATIONS_FAIL:
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_destination.js